import { load } from './_load.js';
import { object } from './_obj.js';
import { setting } from './_setting.js';

export let listenHistory = {
	jsonURL: "/jlc/listenplus/app/result_history.json",
	currentYear: 0,
	data: [],
	filterData:[],
	currentData: {},
	init: function(){
		let now  = new Date();
		let year = now.getFullYear();
		this.currentYear = year;
		let apiURL = this.jsonURL;
		if(location.hostname.includes("kentaromi.tokyo") || location.hostname.includes("macbook-pro.local")){
			
		}else{
			apiURL = setting.history;
		}
		load.getJson(apiURL, {}).then( (res) =>{
			listenHistory.data = res.data.listening_data.monthly_result;
			if(res.data.listening_data.jme_member_id === ""){
				
			}else{
				
			}
			console.log("history:", listenHistory.currentYear, res);
			listenHistory.filter();
		});
		document.querySelector("body").classList.remove("disable");
	},
	filter: function(){
		var obj = {
			year: 0,
			monthly: []
		}
		listenHistory.filterData = [];
		console.log(listenHistory.data);
		let before = 0;
		let yearData = {};
		for(let i = 0; i < listenHistory.data.length; i++){
			let data 		= listenHistory.data[i];
			let date 		= data.date;
			let dateArry 	= date.split("-");
			let y 			= dateArry[0];
			if(before != y){
				if(i > 0){
					listenHistory.filterData.push(yearData);
				}
				yearData = object(obj);
				yearData.year = parseInt(y);
				yearData.monthly = [];
				yearData.monthly.push(data);
			}else{
				yearData.monthly.push(data);
			}
			before = y;
			if(i === listenHistory.data.length - 1){
				listenHistory.filterData.push(yearData);
			}
		}
		let navHTML = "";
		for(let j = 0; j < listenHistory.filterData.length; j++){
			if( listenHistory.currentYear === listenHistory.filterData[j].year){
				listenHistory.currentData = listenHistory.filterData[j];
				navHTML += `<option value="${listenHistory.filterData[j].year}" selected>${listenHistory.filterData[j].year}</option>`;
			}else{
				navHTML += `<option value="${listenHistory.filterData[j].year}">${listenHistory.filterData[j].year}</option>`;
			}
		}
		document.querySelector("select#select_year").innerHTML = navHTML;
		listenHistory.makeChart();
	},
	makeChart: function(){
		let HTML = "";
		let data = listenHistory.currentData;
		for(let j = 0; j < data.monthly.length; j++){
			let d = data.monthly[j];
			d.date = parseFloat( d.date.replace("-", ".") );
		}
		let monthlyData = data.monthly.sort((a,b) => b.date - a.date);
		data.monthly = monthlyData;
		//console.log(data.monthly);
		for(let i = 0; i < data.monthly.length; i++){
			let d = data.monthly[i];
			let date = d.date;
			//console.log(d.date);
			let m = String(d.date).split(".")[1];
			m = parseInt(m);
			//console.log(m);
			let isClear = listenHistory.checkTime(d.time);
			let clearIcon = "";
			if(isClear){
				clearIcon = `<div class="icon"><svg role="img"><title>CLEAR</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/jlc/listenplus/app/assets/images/common/sprite.svg#icon_pass"></use></svg></div>`;
			}
			let hm = listenHistory.calcTime(d.time);
			let params = listenHistory.getColor(d.time);
			let colorCls = "step" + params.num;
			HTML 	+= `<li>
							<div class="time">
								<p>${hm}</p>
							</div>
							<div class="cols">
								<div class="month">
									<p>${m}<span>月</span></p>
								</div>
								<div class="bar_area">
									<div class="bar"><span style="width: ${params.width}%" class="${colorCls}"></span></div>
								</div>
								${clearIcon}
							</div>
						</li>`;
		}
		document.querySelector("ul.list_graph").innerHTML = HTML;
		listenHistory.nav();
	},
	nav: function(){
		let $select = document.querySelector("select#select_year");
		$select.removeEventListener("change", listenHistory.changeYear, false);
		$select.addEventListener("change", listenHistory.changeYear, false);
	},
	checkTime: function(time){
		let border = 60*50;
		let isClear = false;
		if(time >= border){
			isClear = true;
		}
		return isClear;
	},
	calcTime: function(time){
		let h = Math.floor(time/60);
		let m = ( '00' + Math.floor(time%60) ).slice( -2 );;
		return `${h}<span>h</span> ${m}<span>m</span>`;
	},
	getColor: function(time){
		let over50 = 60*50;
		let over100 = 60*100;
		let num = 0;
		let w = 0;
		if( time < over50 ){
			num = 0;
			w = time/over50*100;
		}else if( time >= over50 && time < over100){
			num = 1;
			w = 100;
		}else if( time >= over100 ){
			num = 2;
			w = 100;
		}
		//console.log(w);
		let param = {
			num: num,
			width: w
		}
		return param;
	},
	changeYear: function(){
		let year = parseInt( this.options[this.selectedIndex].value );
		for(let j = 0; j < listenHistory.filterData.length; j++){
			//console.log( year,listenHistory.filterData[j].year)
			if( year === listenHistory.filterData[j].year){
				listenHistory.currentData = listenHistory.filterData[j];
			}
		}
		window.scrollTo(0, 0);
		listenHistory.makeChart();
	}
}